<template>
  <div class="album-list">
    <ul>
      <li v-for="item in albumList" :key="item.id" @click="handler(item.albumId)">
        <img class="img" :src="item.picture" alt="">
        <p>{{item.name}}</p>
      </li>
    </ul>
    <div class="btn" v-if="!isNative"><a :href="downloadPath">查看VIP全部课程<img src="/images/goods/pkg13.png" alt=""></a></div>
    <div class="btn" v-else @click="navigateTo">查看VIP全部课程<img src="/images/goods/pkg13.png" alt=""></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["albumList"],
  methods: {
    handler(id) {
      if (this.isNative) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "album",
          params: {
            id
          }
        });
      } else {
        this.$router.push(`/goods/detail/${id}`);
      }
    },
    navigateTo() {
      this.$store.dispatch("externalInterface/navigateTo", {
        name: "vipZone"
      });
    }
  },
  computed: {
    ...mapGetters({
      isNative: "externalInterface/isNative",
      downloadPath: "externalInterface/downloadApp"
    })
  }
};
</script>
<style scoped>
.album-list {
  width: 100vw;
  background: #fff8f0;
}
.img {
  width: 94px;
  height: 94px;
  border-radius: 12px;
}
.album-list p {
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #515224;
  text-align: center;
  width: 100%;
  font-size: 14px;
}
ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 320px;
  margin: 0 auto;
}
ul li {
  flex: 0 0 auto;
  width: 94px;
}
.btn {
  width: 320px;
  margin: 0 auto;
  background: #ff9168;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  height: 48px;
  line-height: 48px;
  border-radius: 8px;
}
.btn img {
  margin-left: 9px;
}
.btn a {
  display: block;
  color: #fff;
}
a {
  display: block;
}
</style>